export default __webpack_public_path__ + "static/media/Team1.cc282d2d.png";